module.exports = __webpack_public_path__ + "static/media/Strong.02ed22e9.png";